<template>
    <div :class="item.level > 1 ? 'child-row' : ''">
        <div class="item-block ml-1">
            <div class="item-text">
                <div
                    v-if="item.child.length || item.childLength > 0"
                    :class="[
                        'toggle-icon',
                        item.visible ? '--isOpen' : '--isClosed',
                        '__no-action-default'
                    ]"
                    @click="() => toggleCollapse(item)"
                >
                    <ArrowDown />
                </div>
                <div
                    v-else
                    class="child-row"
                ></div>
            </div>
            <div
                :class="[
                    'info-block',
                    verifyIsOpen(item) ? 'openned-block' : '',
                    `level-${item.level}`,
                    item.name.replaceAll(' ', '')
                ]"
            >
                <div class="first-column">
                    <div
                        v-if="item.checked == null || !item.checked"
                        class="icons-and-checkbox"
                    >
                        <div
                            v-if="item.fieldType"
                            class="fields-icons"
                        >
                            <component :is="getIconByType(item.fieldType)" />
                        </div>
                        <div v-else>
                            <div
                                v-for="icon in levelIcons"
                                :key="icon.techName"
                            >
                                <div
                                    v-if="icon.level == level"
                                    :class="[
                                        'icon',
                                        icon.techName === 'Department' || icon.techName === 'Group'
                                            ? 'rounded-icon'
                                            : '',
                                        icon.techName === 'Material' ? 'material-stroke' : ''
                                    ]"
                                >
                                    <component :is="icon.icon" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        :class="[
                            'checkbox-container',
                            item.checked ? 'checked' : '',
                            '__no-action-default'
                        ]"
                        @click="toggleCheckbox(item)"
                    >
                        <span class="icon-checkbox"><CheckIcon /></span>
                    </div>
                    <div class="text-block">
                        <p class="title">
                            {{
                                (isMaterials && (level === 1 || level === 4)) ||
                                (isOrder && item.level === 3)
                                    ? `${item.code} • ${item.name}`
                                    : (isMaterials && level === 3) || (isOrder && item.level === 2)
                                      ? `${item.number} • ${item.name}`
                                      : item.name
                            }}
                        </p>
                        <p
                            v-if="
                                (item.child.length || item.childLength > 0 || item.isMaterials) &&
                                !isDataFields &&
                                !isOrder
                            "
                            class="subtitle"
                        >
                            {{
                                item.isMaterials
                                    ? `${$t("MaterialsPage.Required")} ${item.required ? formatCurrencyWithoutSymbol(item.required) : "0,00"}`
                                    : isOrder && item.level === 1
                                      ? `${item.materialCode} • ${item.materialName} ${$t("and")} ${item.routeName}`
                                      : `${item.child.length || item.childLength}  ${subtitlePlural(item)}`
                            }}
                        </p>

                        <p
                            v-if="isOrder"
                            class="subtitle"
                        >
                            {{ handleOrderSubtitle(item) }}
                        </p>
                    </div>
                    <div
                        v-if="item.default"
                        class="d-flex align-items-center"
                    >
                        <DefaultRouteIcon />
                    </div>
                </div>
                <div
                    class="second-column"
                    :ref="`optionRef-collapse-${item.id}`"
                >
                    <div
                        v-for="option in optionIcons"
                        :key="option.title"
                        :class="[
                            !option.showOnLast || option.showOnLast === level ? '' : 'd-none',
                            showOptionIcons(option, item) ? '' : 'd-none'
                        ]"
                    >
                        <div
                            :id="
                                item.parentId
                                    ? `${option.title}-${item.id}-${item.parentId}-level-${level}`
                                    : `${option.title}-${item.name}-${item.id}-level-${level}`
                            "
                            :class="[
                                !option.showOnLast || option.showOnLast === level
                                    ? 'option-button'
                                    : '',
                                option.removeOnMobile ? 'remove-on-mobile' : '',
                                '__no-action-default'
                            ]"
                            @click="option.click(item)"
                            tabindex="0"
                        >
                            <component
                                v-if="showOptionIcons(item, item)"
                                :is="option.icon"
                            />
                            <div
                                v-if="
                                    (!option.showOnLast || option.showOnLast === level) &&
                                    (item.users || item.quantityUsers !== null) &&
                                    option.title.includes('People')
                                "
                                class="total-amount"
                            >
                                {{ item.users ? item.users.length : item.quantityUsers }}
                            </div>
                            <div
                                v-if="
                                    (!option.showOnLast || option.showOnLast === level) &&
                                    item.quantityResources !== null &&
                                    option.title.includes('Resources')
                                "
                                class="total-amount"
                            >
                                {{ item.quantityResources }}
                            </div>
                            <div
                                v-if="item.child.length > 0 && option.title.includes('DataFields')"
                                class="total-amount"
                            >
                                {{ item.child.length }}
                            </div>
                            <Tooltip
                                v-if="
                                    (!option.showOnLast || option.showOnLast === level) &&
                                    !option.title.includes('Info')
                                "
                                :target="`${option.title}-${item.name}-${item.id}-level-${level}`"
                                :text="$t(option.title)"
                                placement="top"
                            />
                            <Tooltip
                                v-if="option.title.includes('DataFields')"
                                :target="`${option.title}-${item.name}-${item.id}-level-${level}`"
                                placement="top"
                                >{{ $t("DataFieldsPage.DataFields") }}
                            </Tooltip>
                            <Tooltip
                                v-if="option.title.includes('Info')"
                                :target="
                                    item.parentId
                                        ? `${option.title}-${item.id}-${item.parentId}-level-${level}`
                                        : `${option.title}-${item.name}-${item.id}-level-${level}`
                                "
                                placement="top"
                            >
                                <div
                                    v-if="!isDataFields"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label>
                                        {{ $t(levelIcons.find((e) => e.level === level).title) }}
                                    </label>
                                    <span>
                                        {{ item.name }}
                                    </span>
                                </div>
                                <div
                                    v-else
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label>
                                        {{ $t("IntegrationPage.NameField") }}
                                    </label>
                                    <span>
                                        {{ item.name }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.number"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("MaterialsPage.Number") }} </label>
                                    <span>
                                        {{ item.number }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.operationStatus"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label>
                                        <span>
                                            {{ $t("ProductionList.Status") }}
                                        </span>
                                    </label>
                                    <span class="status">
                                        <div :class="['status-color', item.operationStatus]"></div>
                                        {{ item.operationStatus }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.guid"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> Guid </label>
                                    <span>
                                        {{ item.guid }}
                                    </span>
                                </div>
                                <div
                                    v-if="
                                        levelIcons.find((e) => e.level === level).techName ===
                                            'WorkCenter' ||
                                        levelIcons.find((e) => e.level === level).techName ===
                                            'Material' ||
                                        levelIcons.find((e) => e.level === level).techName ===
                                            'UsedMaterial'
                                    "
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("ResourceStatus.Code") }} </label>
                                    <span>
                                        {{ item.code }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.serial_number || item.serialNumber"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("MaterialsPage.SerialNumber") }} </label>
                                    <span>
                                        {{
                                            item.serialNumber
                                                ? item.serialNumber
                                                : item.serial_number
                                        }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.functions"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("DepartmentPage.Function2") }} </label>
                                    <div class="d-flex">
                                        <span
                                            v-for="(func, index) in item.functions"
                                            :key="func"
                                        >
                                            <div class="functions-name">
                                                {{ getFunctionsName(rolesList, func) }}
                                                <span
                                                    class="comma"
                                                    v-if="index != item.functions.length - 1"
                                                    >,</span
                                                >
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        levelIcons.find((e) => e.level === level).techName !==
                                            'WorkCenter' && item.description
                                    "
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("DepartmentPage.Description") }} </label>
                                    <span>
                                        {{ item.description }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.required === false || item.required === true"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("DataFieldsPage.MandatoryField") }} </label>
                                    <span>
                                        {{ item.required ? $t("Yes") : $t("No") }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.important === false || item.important === true"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("DataFieldsPage.ImportantField") }} </label>
                                    <span>
                                        {{ item.important ? $t("Yes") : $t("No") }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.fieldType"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("DataFieldsPage.Formatting") }} </label>
                                    <span>
                                        {{ $t(`DataFieldsPage.${item.fieldType}`) }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.exhibitionLocation && item.exhibitionLocation.length"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("DataFieldsPage.WhereToShow") }} </label>
                                    <div class="text-left">
                                        <span
                                            v-for="(e, index) of item.exhibitionLocation"
                                            :key="e"
                                        >
                                            {{
                                                $t(
                                                    `DataFieldsPage.${
                                                        exhibitionLocationList.find(
                                                            (e) => e.id == e
                                                        ).name
                                                    }`
                                                )
                                            }}<span
                                                v-if="index !== item.exhibitionLocation.length - 1"
                                                >,
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div
                                    v-if="item.responsibleUsers"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label>{{ $t("DepartmentPage.Responsible") }}</label>
                                    <span
                                        v-for="responsible in item.responsibleUsers"
                                        :key="responsible"
                                    >
                                        {{ getResponsibleName(responsibleList, responsible) }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.priority"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("OrdersPage.Priority") }} </label>
                                    <span>
                                        {{ item.priority }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.quantity"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("OrdersPage.Quantity") }} </label>
                                    <span>
                                        {{ formatCurrencyWithoutSymbol(item.quantity) }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.deliveryDate"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("OrdersPage.DeliveryDate") }} </label>
                                    <span>
                                        {{ dateFormatter(item.deliveryDate) }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.tags && item.tags.length"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> Tags </label>
                                    <div class="d-flex">
                                        <div class="tag-name">
                                            {{ item.tags.map((e) => e.name).join(" • ") }}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    v-if="item.setupStart"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("OrdersPage.SetupStart") }} </label>
                                    <span>
                                        {{ dateFormatter(item.setupStart) }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.startTime"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("OrdersPage.OperationStart") }} </label>
                                    <span>
                                        {{ dateFormatter(item.startTime) }}
                                    </span>
                                </div>
                                <div
                                    v-if="item.endTime"
                                    class="tooltip-block d-flex flex-column align-items-start"
                                >
                                    <label> {{ $t("OrdersPage.OperationEnd") }} </label>
                                    <span>
                                        {{ dateFormatter(item.endTime) }}
                                    </span>
                                </div>
                            </Tooltip>
                            <Tooltip
                                v-if="option.title.includes('WorkCenter')"
                                :target="
                                    item.parentId
                                        ? `${option.title}-${item.id}-${item.parentId}-level-${level}`
                                        : `${option.title}-${item.name}-${item.id}-level-${level}`
                                "
                                placement="top"
                            >
                                <div class="text-left">
                                    <div>{{ $t("StructurePage.WorkCenter") }}:</div>
                                    <div>{{ item.workcenter }}</div>
                                </div>
                            </Tooltip>
                            <Tooltip
                                v-if="option.title.includes('Actions')"
                                :target="
                                    item.parentId
                                        ? `${option.title}-${item.id}-${item.parentId}-level-${level}`
                                        : `${option.title}-${item.name}-${item.id}-level-${level}`
                                "
                                placement="top"
                            >
                                <div class="text-left">
                                    <div>{{ $t(option.title) }}</div>
                                </div>
                            </Tooltip>
                            <Tooltip
                                v-if="option.title.includes('OpenMaterial')"
                                :target="
                                    item.parentId
                                        ? `${option.title}-${item.id}-${item.parentId}-level-${level}`
                                        : `${option.title}-${item.name}-${item.id}-level-${level}`
                                "
                                placement="top"
                            >
                                <div class="text-left">
                                    <div>{{ $t("MaterialsPage.OpenMaterial") }}</div>
                                </div>
                            </Tooltip>
                            <Popover
                                v-if="option.title.includes('Actions')"
                                :items="removeItemsByLevel(option.actions, item)"
                                :target="
                                    item.parentId
                                        ? `${option.title}-${item.id}-${item.parentId}-level-${level}`
                                        : `${option.title}-${item.name}-${item.id}-level-${level}`
                                "
                                placement="bottom"
                                :levelIcons="levelIcons"
                                :level="level + 1"
                                :customStyle="isMaterials || isOrder"
                                :isDataFields="isDataFields"
                                :customPosition="
                                    isMaterials || isOrder
                                        ? '--max-content'
                                        : option.actions.length > 2
                                          ? '--max-content'
                                          : 'action-button'
                                "
                                triggers="focus"
                                @onShow="onShow(item.id, item.type, item.parentId)"
                                @onHidden="onHidden(item.id)"
                                @click="editInfos(item.id, level, item.type, item.parentId)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-collapse :visible="visible">
            <div
                v-if="item.child && (item.child.length || item.childLengh > 0)"
                class="ml-3"
            >
                <RecursiveItem
                    v-for="(childItem, index) in item.child"
                    :key="childItem.id || index"
                    :item="childItem"
                    :level="level + 1"
                    :levelIcons="levelIcons"
                    :optionIcons="optionIcons"
                    :isMaterials="isMaterials"
                    :isDataFields="isDataFields"
                    :isOrder="isOrder"
                    @checksCounter="emitChecksCounter"
                    @isAllChildrenChecked="isAllChildrenChecked"
                    @getEditInfos="(id, lvl, type, parentId) => editInfos(id, lvl, type, parentId)"
                />
            </div>
        </b-collapse>
    </div>
</template>
<script>
    import { BCollapse } from "bootstrap-vue";
    import ArrowDown from "@core/assets/icons/arrow-down.svg";
    import CheckIcon from "@core/assets/icons/check-icon.svg";
    import DefaultRouteIcon from "@core/assets/icons/default-route-icon.svg";
    import Tooltip from "@/@core/layouts/layout-horizontal/components/Menu/Tooltip.vue";
    import Popover from "@/@core/layouts/layout-horizontal/components/Menu/Popover.vue";
    import moment from "moment";
    import { formatCurrencyWithoutSymbol } from "@/utils/format";

    export default {
        name: "RecursiveItem",
        components: { BCollapse, ArrowDown, CheckIcon, DefaultRouteIcon, Tooltip, Popover },
        props: {
            item: { type: Object, required: true },
            levelIcons: {
                type: Array,
                required: true
            },
            optionIcons: {
                type: Array,
                required: true
            },
            isMaterials: {
                type: Boolean,
                default: false
            },
            isOrder: {
                type: Boolean,
                default: false
            },
            isDataFields: {
                type: Boolean,
                default: false
            },
            level: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                visible: this.item.visible ?? false,
                formatCurrencyWithoutSymbol: formatCurrencyWithoutSymbol
            };
        },
        methods: {
            toggleCollapse(item) {
                this.visible = !this.visible;
                item["visible"] = this.visible;
                this.visible && this.$emit("collapseOpenned", this.item);
            },
            handleOrderSubtitle(item) {
                if (item.isMaterials)
                    return `${this.$t("MaterialsPage.Required")} ${item.required ? formatCurrencyWithoutSymbol(item.required) : "0,00"}`;
                if (item.level === 1)
                    return `${item.materialCode} • ${item.materialName} ${this.$t("and")} ${item.routeName}`;
                if (item.child?.length) return `${item.child.length} ${this.subtitlePlural(item)}`;
                return "";
            },
            dateFormatter(value) {
                return moment(value).format("DD/MM/YYYY HH:mm");
            },
            verifyIsOpen(item) {
                const isOpen = item.visible == null || item.visible;
                if (this.isChild) {
                    return isOpen && item.child.length > 0;
                } else {
                    return isOpen && item.child.length > 0;
                }
            },
            subtitlePlural(item) {
                let title = this.$t(this.levelIcons.find((e) => e.level === this.level + 1).title);
                const currentLanguage = this.$cookies.get("userInfo").language;

                if (currentLanguage === "en-US") {
                    return `${title}${item.child.length > 1 || item.childLength > 1 ? "s" : ""}`;
                }

                if (
                    currentLanguage === "pt-BR" &&
                    (item.child.length > 1 || item.childLength > 1)
                ) {
                    if (title.endsWith("ão")) {
                        title = title.replace(/ão$/g, "ões");
                    } else if (title.endsWith("al")) {
                        title = title.replace(/al$/g, "ais");
                    }

                    if (
                        title.endsWith("a") ||
                        title.endsWith("e") ||
                        title.endsWith("i") ||
                        title.endsWith("o") ||
                        title.endsWith("u")
                    ) {
                        title += "s";
                    }
                }
                return title;
            },
            showOptionIcons(item, elem) {
                if (this.isDataFields) {
                    if (item.title.includes("DataFields") && elem.type === "field") {
                        return null;
                    }
                    if (item.title.includes("Info") && elem.type === "group") {
                        return null;
                    }
                    return item;
                }
                return !item.showOnLast || item.showOnLast === this.level;
            },
            removeItemsByLevel(actions, item) {
                if (this.isOrder) {
                    return actions.map((e) => {
                        if (e.title.includes("New") && this.level !== 1) {
                            return null;
                        }
                        if (e.title.includes("LinkMaterial") && this.level !== 2) {
                            return null;
                        }
                        if (e.title.includes("UnlinkMaterial") && this.level !== 3) {
                            return null;
                        }
                        if (e.title.includes("LinkOperation") && this.level !== 1) {
                            return null;
                        }
                        if (
                            e.title.includes("UnlinkOperation") &&
                            (item.canBeDeleted || item.level !== 2)
                        ) {
                            return null;
                        }
                        if (
                            item.level === 2 &&
                            !item.canBeDeleted &&
                            (e.title.includes("Duplicate") || e.title.includes("Delete"))
                        ) {
                            return null;
                        }
                        if (
                            e.title.includes("Duplicate") &&
                            this.level == this.getLastLevel(this.levelIcons)
                        ) {
                            return null;
                        }
                        if (
                            e.title.includes("Delete") &&
                            this.level == this.getLastLevel(this.levelIcons)
                        ) {
                            return null;
                        }

                        return e;
                    });
                }

                if (this.isMaterials) {
                    return actions.map((e) => {
                        if (e.title.includes("New") && (this.level === 3 || this.level === 4)) {
                            return null;
                        }
                        if (e.title.includes("Link") && this.level !== 3) {
                            return null;
                        }
                        if (e.title.includes("Unlink") && this.level !== 4) {
                            return null;
                        }
                        if (
                            e.title.includes("Duplicate") &&
                            this.level == this.getLastLevel(this.levelIcons)
                        ) {
                            return null;
                        }
                        if (
                            e.title.includes("Delete") &&
                            this.level == this.getLastLevel(this.levelIcons)
                        ) {
                            return null;
                        }
                        if (e.title.includes("New") && this.level === 2) {
                            return { ...e, title: "DepartmentPage.Newa" };
                        }
                        return e;
                    });
                }
                return actions.map((e) => {
                    if (
                        e.title.includes("New") &&
                        this.level === this.getLastLevel(this.levelIcons)
                    ) {
                        return null;
                    }

                    return e;
                });
            },
            onShow(id, type, parentId) {
                const optionRef = `optionRef-collapse-${id}`;
                this.$refs[optionRef].classList.add("popover-openned");
                this.editInfos(id, this.level, type, parentId);
            },
            onHidden(id) {
                const optionRef = `optionRef-collapse-${id}`;
                this.$refs[optionRef].classList.remove("popover-openned");
            },
            editInfos(id, level, type, parentId) {
                this.$emit("getEditInfos", id, level, type, parentId);
            },
            getLastLevel(data) {
                let lastLevel = -Infinity;
                for (const item of data) {
                    const level = typeof item.level === "number" ? item.level : -Infinity;
                    lastLevel = Math.max(lastLevel, level);
                }

                return lastLevel;
            },
            isAllChildrenChecked() {
                this.$emit("isAllChildrenChecked");
            },
            toggleCheckbox(item) {
                const newValue = !item.checked;

                this.$set(item, "checked", newValue);

                this.checkChildren(item, newValue);

                this.isAllChildrenChecked();

                this.emitChecksCounter();
            },
            checkChildren(item, value) {
                const targetValue = value !== undefined ? value : true;

                if (item.child) {
                    item.child.forEach((child) => {
                        this.$set(child, "checked", targetValue);

                        this.checkChildren(child, targetValue);
                    });
                }
            },
            emitChecksCounter() {
                this.$emit("checksCounter");
            }
        }
    };
</script>
<style lang="scss">
    .tooltip-inner:has(.tooltip-block) {
        max-width: 300px !important;
        min-width: 300px !important;
        width: 100% !important;
    }
    .tooltip-block {
        display: flex;
        flex-direction: column;
        align-items: start;
        text-align: left;
        padding-bottom: 10px;
        font-size: 14px;
        line-height: 20px;

        .status {
            display: flex;
            align-items: center;
            gap: 4px;

            .status-color {
                width: 8px;
                height: 8px;
                aspect-ratio: 1 / 1;
                border-radius: 50%;

                &.InProduction {
                    background: #f5b200;
                }

                &.Released {
                    background: #61b3fa;
                }

                &.Finished {
                    background: #1abd17;
                }
            }
        }

        label {
            color: #fff;
            margin: 0;
            font-weight: 600;
        }

        span {
            font-weight: 400;
            text-align: left;
        }

        .functions-name,
        .tag-name {
            display: flex;
            flex-wrap: wrap;

            .comma {
                padding-right: 4px;
            }
        }

        &:last-child {
            padding-bottom: 0;
        }
    }
</style>
<style lang="scss" scoped>
    .child-row {
        border-left: 1px solid #974900;
        padding-left: 16px;
        margin-left: -13px;
    }

    .item-block {
        display: flex;
        padding: 4px 8px;
        gap: 8px;

        .item-text {
            display: flex;
            align-items: center;
            .toggle-icon {
                display: flex;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                border: 1px solid #cfc4be;
                cursor: pointer;

                &.--isOpen {
                    transform: rotate(180deg);
                }
                &.--isOpen {
                    transform: rotate(-180deg);
                }

                svg {
                    fill: #4c4541;
                }

                &:hover {
                    border-color: #974900;
                    background-color: #ffede2;

                    svg {
                        fill: #974900;
                    }
                }

                &:active {
                    border-color: #974900;
                    background-color: #ffdbc4;

                    svg {
                        fill: #974900;
                    }
                }
            }
        }

        .info-block {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            padding: 4px 8px;
            border-radius: 4px;

            &.normal-cursor {
                cursor: auto;
            }

            &:has(.first-column:active) {
                background-color: #ffdbc4;
            }

            .first-column {
                display: flex;
                min-height: 28px;
                gap: 8px;
                width: 100%;
                align-items: center;
                overflow: hidden;
                font-variant-numeric: lining-nums proportional-nums;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 80%;

                .fields-icons {
                    svg {
                        fill: #4c4541;
                        width: 18px;
                        height: 18px;
                    }
                }

                .checkbox-container {
                    width: 100%;
                    height: 18px;
                    max-width: 18px;
                }

                .text-block {
                    overflow: hidden;
                    font-variant-numeric: lining-nums proportional-nums;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .second-column {
                display: flex;
                opacity: 0;
                max-height: 28px;
                &.popover-openned {
                    display: flex;
                    gap: 8px;
                }
                .option-button {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    cursor: pointer;
                    padding: 8px;
                    border-radius: 6px;
                    svg {
                        width: 12px;
                        height: 12px;
                        fill: #974900;
                    }

                    .total-amount {
                        color: #974900;
                        font-variant-numeric: lining-nums proportional-nums;
                        font-size: 10px;
                        font-weight: 600;
                        line-height: 14px;
                    }

                    &:hover {
                        background: #ffede2;
                    }
                    &:active {
                        background: #ffdbc4;
                    }
                }
            }

            &.openned-block {
                .icon {
                    &.rounded-icon {
                        border-color: #974900;
                    }
                    &.material-stroke {
                        svg {
                            stroke: #974900;
                        }
                    }
                    svg {
                        fill: #974900;
                    }
                }
                .text-block {
                    .title,
                    .subtitle {
                        color: #974900;
                    }
                }
            }
            .icon {
                display: flex;
                width: 18px;
                height: 18px;
                border-radius: 50%;
                &.rounded-icon {
                    border: 1px solid #4c4541;
                }
                svg {
                    fill: #4c4541;
                }
            }

            .checkbox-container {
                display: none;
                background-color: #fff;
                border: 1px solid #cfc4be;
                border-radius: 3px;
                cursor: pointer;
                width: 18px;
                height: 18px;

                .icon-checkbox {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 2px;
                    svg {
                        width: 12px;
                        height: 12px;
                    }
                }
                &.checked {
                    background-color: #974900;
                    display: block;
                }
            }

            .text-block {
                .title,
                .subtitle {
                    overflow: hidden;
                    font-variant-numeric: lining-nums proportional-nums;
                    text-overflow: ellipsis;
                    margin: 0;
                }

                .title {
                    color: #4c4541;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 20px;
                }

                .subtitle {
                    color: #7e7570;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16px;
                }
            }

            &:hover,
            &:has(.popover-openned) {
                background-color: #ffede2;

                .first-column {
                    .icons-and-checkbox {
                        display: none;
                    }
                }

                .second-column {
                    opacity: 1;
                    gap: 8px;
                }
                .icon {
                    display: none;
                }

                .checkbox-container {
                    display: block;
                }

                @media (max-width: 480px) {
                    .text-block {
                        max-width: 85px;
                    }
                }
                .text-block {
                    .title,
                    .subtitle {
                        white-space: nowrap;
                        color: #974900;
                    }
                }
            }

            &:active {
                .text-block {
                    .title,
                    .subtitle {
                        color: #974900;
                    }
                }
            }
        }
    }
</style>
